import React from 'react';
import './TextAssessmentChip.scss';

const TextAssessmentChip = ({ text, isSelected, chipClass, selectedClass, onClick }) => {
  return (
    <div
      className={`skin-chip ${chipClass ?? ''} ${isSelected ? (selectedClass ?? 'green-chip') : ''}`}
      onClick={onClick}>
      {text}
    </div>
  );
};

export default TextAssessmentChip;